import { render, staticRenderFns } from "./DialogAddCommitment.vue?vue&type=template&id=e15e8d04&scoped=true"
import script from "./DialogAddCommitment.vue?vue&type=script&lang=js"
export * from "./DialogAddCommitment.vue?vue&type=script&lang=js"
import style0 from "./DialogAddCommitment.vue?vue&type=style&index=0&id=e15e8d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15e8d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
